import React from 'react';
import { useTheme } from 'styled-components';
import { Typography, Toggle } from '@statsbomb/kitbag-components';
import { useStore } from '../../../../store/useStore';
import { trackObjectChangeEvent } from '../../../../utils/helpers/snowplow';
import { ScoutToggleWrapper } from '../BiometricFilters/BiometricFilters.styles';

const ScoutFavouritesToggle = () => {
  const theme = useTheme();
  const showFavourites = useStore((s) => s.showFavourites);
  const setShowFavourites = useStore((s) => s.setShowFavourites);
  return (
    <ScoutToggleWrapper style={{ marginTop: theme.sizing.regular }}>
      <Typography variant="headingSmall">Favorites</Typography>
      <Toggle
        id="favourites-toggle"
        label="Show favorites only"
        onChange={() => {
          trackObjectChangeEvent('Widget', 'Edit', 'showfavourites');
          setShowFavourites(!showFavourites);
        }}
        checked={showFavourites}
        size="small"
        testId="favourites-only-toggle"
      />
    </ScoutToggleWrapper>
  );
};

export default ScoutFavouritesToggle;
